import React, { useState, useContext, useEffect } from "react";
import { useMutation, gql, useQuery } from "@apollo/client";

import "../../assets/css/Login.css";
import Error from "../../components/Error";
import {
  Backdrop,
  CircularProgress,
  OutlinedInput,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { SIGNUP_USER_GOOGLE } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
const { DateTime } = require("luxon");
const getUsers = gql`
  query {
    users {
      id
      email
      password
      username
      token
      resetToken
      resetTokenExpiry
      role
      url
      timezone
    }
  }
`;
const SIGNUP_USER = gql`
  mutation (
    $email: String!
    $password: String!
    $username: String!
    $url: String!
  ) {
    signUp(email: $email, password: $password, username: $username, url: $url) {
      token
    }
  }
`;
function SignUp(props) {
  const [email, setEmail] = useState(
    new URLSearchParams(window.location.search).get("email")
      ? new URLSearchParams(window.location.search).get("email")
      : ""
  );

  // const [phone, setPhone] = useState("");
  const [signUpWithGoogleMutation] = useMutation(SIGNUP_USER_GOOGLE);
  const [error, setError] = useState([]);
  const [fullname, setName] = useState("");
  const [password, setPassword] = useState("");

  const [passwordConfirm, setPasswordConfirm] = useState("");
  const signUp = useGoogleLogin({
    onSuccess: (response) => {
      // Call the signUpWithGoogle mutation with the Google token

      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${response.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          var finalUrl = res.data.name.toLowerCase().replace(/\s/g, "");
          var count = 0;
          while (true) {
            if (
              !data.users.find(
                (obj) => obj.url == finalUrl + (count ? count : "")
              )
            ) {
              break;
            }
            count++;
          }
          signUpWithGoogleMutation({
            variables: {
              email: res.data.email,
              username: res.data.name,
              url: finalUrl + (count ? count : ""),
            },
          })
            .then((result) => {
              localStorage.setItem("token", result?.data?.signUpGoogle?.token);
              props.login(result?.data?.signUpGoogle?.token);
              // window.location.href = "/app/events";
            })
            .catch((err) => {
              if (err.message === "Validation error") {
                setError("Existing account with provided email");
              }
            });
        });
    },
    onFailure: (error) => console.log("Signup Failed:", error),
  });
  // const [signUpUser, { error: mutationError,data }] = useMutation(SIGNUP_USER);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const [signUpUser] = useMutation(SIGNUP_USER);
  const { loading, error: errors, data } = useQuery(getUsers);
  const navigate = useNavigate();
  if (loading) return "Loading";
  if (errors) {
    return <Error />;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError([]);

    if (passwordConfirm !== password) {
      setError(["Passwords do not match"]);
      return;
    }
    if (!passwordConfirm || !password) {
      setError(["Please answer all inputs"]);
      return;
    }
    var finalUrl = fullname.toLowerCase().replace(/\s/g, "");
    var count = 0;
    while (true) {
      if (
        !data.users.find((obj) => obj.url == finalUrl + (count ? count : ""))
      ) {
        break;
      }
      count++;
    }
    signUpUser({
      variables: {
        email,
        password,
        username: fullname,
        url: finalUrl + (count ? count : ""),
      },
    })
      .then((result) => {
        handleOpen();
        setTimeout(() => {
          handleClose();
          if (document.getElementById("error").innerText) {
            // handle the case when there are errors
            console.log("There were errors:", error);
          } else {
            localStorage.setItem("token", result?.data?.login?.token);
            props.login(result?.data?.login?.token);
            console.log(error);
            navigate("/login?email=" + email);
          }
        }, 500);
      })
      .catch((error) => {
        console.error("Error:", error);
        setError([error.message]);
        if (error.message === "Validation error") {
          setError("Existing account with provided email");
        }
      });
  };
  if (loading) return "Loading...";
  // const classes = useStyles();
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div className="Login-Popup-form">
        <form noValidate onSubmit={handleSubmit} style={{ padding: "30px" }}>
          <h3 className="Loginyouraccount">Make your account</h3>
          <p className="input-label">Email</p>
          <OutlinedInput
            fullWidth
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
          <p className="input-label">Full Name</p>
          <OutlinedInput
            fullWidth
            type="text"
            value={fullname}
            onChange={(e) => setName(e.target.value)}
          />
          <p className="input-label">Password</p>
          <OutlinedInput
            fullWidth
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value.trim())}
          />
          <p className="input-label">Confirm Password</p>
          <OutlinedInput
            fullWidth
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
          />
          <br />
          <button type="submit" className="login-button">
            Login
          </button>
          <p
            id="error"
            style={{
              color: "red",
              display: "flex",
              justifyContent: "flex-end",
              margin: 0,
              height: "50px",
            }}
            className="column"
          >
            {error}
          </p>
        </form>
        <div style={{ padding: "0px 30px 30px 30px" }}>
          <div>
            {/* <h2>React Google Login</h2>
          <br />
          <br />
          {profile ? (
            <div>
              <img src={profile.picture} alt="user image" />
              <h3>User Logged in</h3>
              <p>Name: {profile.name}</p>
              <p>Email Address: {profile.email}</p>
              <br />
              <br />
              <button onClick={logOut}>Log out</button>
            </div>
          ) : ( */}
            <button className="login-with-google-btn" onClick={() => signUp()}>
              Continue with Google
            </button>
            {/* )} */}
          </div>{" "}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            className="flex column"
            style={{ gap: "20px" }}
          >
            <CircularProgress color="inherit" />
            <Typography>Redirecting to Login Page</Typography>
          </Backdrop>
          <div
            style={{ display: "flex", flexDirection: "row", marginTop: "10px" }}
          >
            <p>Already have an account?</p>
            <a href="/login">Sign In</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
